import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a605ad9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "progress_container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "progress_box",
    style: _normalizeStyle({
      width: _ctx.progress + '%'
    })
  }, null, 4)]);
}